<div class="p-ml-1 timer-container">
  <div style="display: flex;">
    <countdown [config]="{ leftTime: countdownTimeSec, format: 'mm:ss', notify: [notifySec] }" (event)="handleEvent($event)"></countdown>
  </div>
</div>
